import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import { FormControlLabel } from '@material-ui/core';

export const SubHeader = styled.h3`
  margin-bottom: 8px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;

  color: ${beam.color.primaryBlue};
  opacity: 1;
`;
export const Text = styled.h3`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  color: ${beam.font.primary};
  opacity: 1;
`;

export const SubText = styled.h3`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  margin-left: 8px;

  color: ${beam.color.pureBlack};
  opacity: 1;
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  width: 15px;
  height: 15px;
`;

export const LinkText = styled.h3`
  color: ${beam.font.link};
  opacity: 1;
`;
